import React, { FC } from 'react';
import DaumPostcode, { AddressData } from 'react-daum-postcode';
import Modal, { ModalProps } from './Modal';

interface ModalPostcodeProps extends ModalProps {
  onSelectAddress: (data: AddressData) => void;
}

const ModalPostcode: FC<ModalPostcodeProps> = ({
  onSelectAddress,
  ...props
}) => (
  <Modal {...props}>
    <DaumPostcode onComplete={onSelectAddress} height="465px" />
  </Modal>
);

export default ModalPostcode;
